<template>
  <div class="button-group">
    <ManagePlanButton v-if="!canEditAlerts" color="secondary" />
    <ButtonWithPaywall
      color="primary"
      @click="openCreateDialog"
      :fallback-action="openFreemiumModal"
    >
      <template #iconLeft>
        <i class="fa-solid fa-plus" />
      </template>
      Ajouter une alerte
    </ButtonWithPaywall>
  </div>
  <div class="englobe-params">
    <div class="infos">
      <i class="fa-regular fa-circle-info"></i>
      <p class="title-medium-regular">
        Configurez vos alertes personnelles pour recevoir les nouveaux éléments
        de votre veille dans le canal de votre choix.<br />
        Choisissez votre canal de préférence ou mettez en pause vos alertes sur
        votre page
        <RouterLink v-focus to="/user-settings/notifications"
          >Préférences de notifications</RouterLink
        >.
      </p>
    </div>
  </div>
  <PopupDialog ref="createModal" title="Ajouter une alerte">
    <template #body>
      <AddEditAlertForm v-if="showForm" ref="createForm" />
    </template>
    <template #footer>
      <button v-if="showForm" v-focus class="btn-primary" @click="createAlert">
        Ajouter
      </button>
    </template>
  </PopupDialog>
</template>

<script setup lang="ts">
import { computed, inject, ref } from "vue";
import { RouterLink } from "vue-router";
import AddEditAlertForm from "../molecules/AddEditAlertForm.vue";
import PopupDialog from "@follaw-fr/components/reusable/atoms/PopupDialog.vue";
import ButtonWithPaywall from "@follaw-fr/components/reusable/molecules/ButtonWithPaywall.vue";
import ManagePlanButton from "@follaw-fr/components/user-settings/atoms/ManagePlanButton.vue";
import { openAlertPaywallModalKey } from "@follaw-fr/constants/injection-keys";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import { PermissionLevel } from "@follaw-fr/constants/enums/permission-level.enum";

const openFreemiumModal = inject(openAlertPaywallModalKey);

const createModal = ref();
const showForm = ref(false);
const { hasPermission } = useUserSettingsStore();
const canEditAlerts = computed(() => hasPermission(PermissionLevel.BASIC));

const openCreateDialog = () => {
  showForm.value = true;
  createModal.value?.open();
};

const createForm = ref();
const createAlert = () => {
  if (createForm.value?.validate()) {
    createForm.value?.form.requestSubmit();
    showForm.value = false;
  }
};
</script>

<style lang="scss" scoped>
.infos {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.938em;
  font-weight: 600;

  p {
    margin: 0;
  }

  i {
    font-size: 1.35em;
  }
}

.button-group {
  display: flex;
  flex-direction: row;
  justify-content: right;
  gap: 10px;
  margin-bottom: 20px;
}
</style>
